import { isArray } from 'lodash-es';

type PredicateFnType<T> = (value: T) => boolean;

export const findNestedArray = <T extends Record<any, any>>(
  arr: T[],
  predicate: PredicateFnType<T>,
  childKey = 'children',
): T | null => {
  if (isArray(arr)) {
    for (const item of arr) {
      if (predicate(item)) return item;

      const current = findNestedArray(item[childKey] as T[], predicate, childKey);
      if (current) return current;
    }
  }
  return null;
};
